import { fetchQuery, graphql } from "relay-runtime"
import {
  medicalRecordLinkIdentifiersQuery,
  medicalRecordLinkIdentifiersQuery$data,
} from "@/modules/admin/advanced/services/__generated__/medicalRecordLinkIdentifiersQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query medicalRecordLinkIdentifiersQuery(
    $patientNodeId: String!
    $appointmentNodeId: String!
    $hasAppointmentNodeId: Boolean!
  ) {
    patient: parseNodeId(nodeId: $patientNodeId) {
      typeName
      internalId
      internalIdRuntimeType
    }
    appointment: parseNodeId(nodeId: $appointmentNodeId) @include(if: $hasAppointmentNodeId) {
      typeName
      internalId
      internalIdRuntimeType
    }
  }
`

export type MedicalRecordLinkIdentifiers = medicalRecordLinkIdentifiersQuery$data

export const fetchMedicalRecordLinkIdentifiers = (
  patientNodeId: string,
  appointmentNodeId: string | null,
): Promise<MedicalRecordLinkIdentifiers | null> =>
  fetchQuery<medicalRecordLinkIdentifiersQuery>(
    RelayEnvironment,
    query,
    { patientNodeId, appointmentNodeId: appointmentNodeId ?? "", hasAppointmentNodeId: appointmentNodeId !== null },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => response ?? null)
